export enum LayerMask {
  Default  = 0x0fffffff,
  Terrain  = 1,
  Decal    = 1 << 1,
  Building = 1 << 2,
  Rooftop  = 1 << 3,
  Complex  = 1 << 4,
  Facility = 1 << 5,
  UnitCollider     = 1 << 6,
  Effect   = 1 << 7,
  Sky      = 1 << 8,
  Active   = 1 << 9,
  UI       = 1 << 10,
  Minimap  = 1 << 11,
}


export const TOUCH_ZOOM_SENSIBILITY = 15;
export const TOUCH_ZOOM_DAMPENING = 70;
export const MOUSE_ZOOM_SENSIBILITY = 40;
export const TOUCH_ZOOM_SENSIBILITY_WEIGHT = 0.0001;
export const MOUSE_ZOOM_SENSIBILITY_WEIGHT = 0.000001;
export const ZOOM_DAMPENING_WEIGHT = 0.01;
export const ROTATION_SENSIBILITY_X = 0.001;
export const ROTATION_SENSIBILITY_Y = 0.001;
export const MAX_UNITS_FOR_HIGH_QUALITY = 5000;
export const MAX_DISTANCE_FROM_UNIT_WINDOW = 2.5;
export const INTERIOR_FOV_DESKTOP = 1.8;
export const INTERIOR_FOV_MOBILE = 1.95;
export const EXTERIOR_FOV = 0.8;
